import { PALETTE } from "../../common/styles/palette"

export const styles = (theme: any) => {
    return {
        root: {
            paddingLeft: '20px'
        },
        contactReservationDialogActions: {
            display: "flex",
            justifyContent: "flex-end",
        },
        contactReservationsList: {
            width: '100%',
            position: 'relative',
            overflowY: 'auto',
            maxHeight: "300px"
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        listSubheaderContainer: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        listSubheader: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        // REMINDER
        reminder: {
            display: 'flex',
            flex: 1,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.HoveredBackGroundColor
            },
        },
        selectedReminder: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.SelectedContact.HoveredBackGroundColor
            },
        },
        checkedred: {
            backgroundColor: "#ff0000",
            color: "white",
        },
        checkedorange: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        checkedorangelt: {
            backgroundColor: "#fcdbbb",
            color: "#ff6600",
        },
        // SUBSCRIPTION
        dayIsDisabled: {
            backgroundColor: '#E85B4A',
            borderBottom: '1px solid #000'
        },
        dayIsEnabled: {
            backgroundColor: '#52FF6D',
            borderBottom: '1px solid #000'
        },
    }
}